export default __webpack_public_path__ + "static/media/calendar_analytics.ef4483ab.svg";